import { render, staticRenderFns } from "./TaskDialog.vue?vue&type=template&id=21c597a4&scoped=true&"
import script from "./TaskDialog.vue?vue&type=script&lang=js&"
export * from "./TaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskDialog.vue?vue&type=style&index=0&id=21c597a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c597a4",
  null
  
)

export default component.exports